import type { Messages } from '../de';

export default {
  card: {
    title: 'Races & personal bests',
    sub: 'Official net time where entered – “~” = total time from the watch. Only confirmed races count. Outline = new in {year}',
    add: 'Add result',
    bests: 'Personal bests',
    repeats: 'Per race',
    noBests: 'No personal best yet. Mark runs as “Race” or add a result.',
    list: 'All races',
    freshSr: 'new in {year}',
    listCount: { one: '{count} race', other: '{count} races' },
    showAll: 'Show all {count}',
    showLess: 'Show less',
    starts: { one: '{count} start', other: '{count} starts' },
    loadError: 'Races not available: {error}',
    suggestions: { one: '{count} run sounds like a race', other: '{count} runs sound like a race' },
    suggestionsHint: 'Recognised by title, counts only once confirmed. Tap “Race” under “Tags” on the run.',
  },
  state: {
    suggested: 'distance suggested',
    missing: 'distance missing',
    watch: 'total watch time',
    fromTitle: 'distance from title',
    fromMeasured: 'distance from measurement',
    manual: 'not recorded',
    timeMissing: 'time missing',
    snapped: 'measured {measured}, suggested as {official}',
    approx: 'approximately, from watch: ',
    dnfAfter: 'stopped after {time}',
    dnfAfterWatch: 'stopped after {time} (total watch time)',
    pbDistance: 'new PB {distance}',
    pbRace: 'new PB in this race',
    watchCompare: 'watch total {time}',
    dnf: 'did not finish',
  },
  form: {
    addTitle: 'Add result',
    editTitle: 'Edit result',
    blockTitle: 'Race',
    name: 'Race',
    namePlaceholder: 'e.g. New Year’s Eve run',
    date: 'Date',
    distance: 'Official distance',
    other: 'Other distance',
    otherKm: 'km',
    none: 'unknown',
    time: 'Net time',
    timePlaceholder: 'h:mm:ss',
    timeHint: 'Empty = total watch time incl. pauses ({watch})',
    timeFormat: 'Format h:mm:ss, 2.07.00 works too',
    nameHint: 'Empty = {name}',
    distanceRule: 'Suggested from the title, or from the measurement if it is within 3 % of 5 km, 10 km, half marathon or marathon. A PB over a standard distance counts within 0.5 %.',
    suggestedOption: '{name} (suggested)',
    saveNext: 'Save & next',
    saved: 'Saved: {name}',
    timeError: 'Enter time as h:mm:ss or mm:ss',
    distanceError: 'Enter the distance in km',
    nameError: 'Race name is missing',
    dnf: 'Did not finish',
    reset: 'Reset entries',
    resetConfirm: 'Delete your entries for this race? The suggestions apply again.',
    deleteConfirm: 'Delete this entered result?',
    measured: 'measured {km}',
    notSaved: 'Not saved: {error}',
  },
  distances: { '5k': '5 km', '10k': '10 km', half: 'Half marathon', marathon: 'Marathon' },
  today: {
    title: { one: 'New personal best', other: '{count} new personal bests' },
    item: '{label}: {time} · {name}, {date}',
    itemRace: '{name}: {time} in this race · {date}',
    watch: '~',
  },
} satisfies Messages['races'];
